<template>
    <div class="new-request__header">
        <span class="new-request__text" v-if="!STATE_request.loading.show && !STATE_request.requestZepplinId">
            <icon name="bar-code" color="#73777B" width="16" height="16" />
            <h3 v-if="utils.isTmp(STATE_request.requestId)">Novo atendimento</h3>
            <h3 v-else @click="openLog(STATE_request.requestId)">{{ STATE_request.requestId }}</h3>
        </span>
        <div v-if="STATE_request.requestZepplinId" class="new-request__text" style="display: flex; align-items: center;">
            <icon name="zepplin" :width="24" :height="24" :color="STATE_request.status === 'pending' ? '#EC424D' : 'var(--font-color)'"/>
            <h3 @click="openLog(STATE_request.requestId)">{{ STATE_request.requestCode }}</h3>
        </div>
        <!-- <icon-wh-call v-if="!STATE_request.loading.show"></icon-wh-call>
        <span class="new-request__text" v-if="!STATE_request.loading.show" >
            <app-select downIcon="true" :value="getPhoneLine" :items="getPhoneLines" style="width: 100%;" :popoverProps="{verticalOffset: 0, horizontalOffset: -15, placement: 'bottom-start'}"
                @input="selectPhoneLine($event)">
                <input type="text" class="select readonly" style="margin-bottom: 8px; border: none;" readonly :value="getPhoneLine" />
                <template slot="item" slot-scope="slotProps">
                    <span>{{ slotProps.text }}</span>
                </template>
            </app-select>
        </span> -->
        <span style="flex-grow: 1"></span>
        <div class="new-request__img">
            <!-- <icon-wh-share></icon-wh-share>
            <div class="new-request-circ">
                <span>0</span>
            </div>
            <icon-wh-chat></icon-wh-chat>
            <div class="new-request-circ">
                <span>0</span>
            </div>
            <icon-wh-log></icon-wh-log>
            <div class="new-request-circ">
                <span>0</span>
            </div> -->
            <div @click="close()" v-if="!STATE_request.loading.show">
                <icon 
                name="delete" 
                style="cursor: pointer" 
                color="var(--font-color--terciary)"
                width="24" 
                height="24" 
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    props: ['STATE_request'],
    computed: {
        ...mapState("auth", ["user", "accessToken", 'company']),
    },
    methods: {
        close() {
            if(this.STATE_request.loading.show) return 
            this.STATE_request.closeWindow(this)
        },
        openLog(requestId) {
            if(this.VXORM.CompanyUser.hasPermission(this.user.id, 'request-log', 'view'))
                this.$emit('showLog', true)
        }
    }
}
</script>

<style lang="scss">
    .new-request__header {
        height: 100%;
        width: 100%;
        background-color: #23272B;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-shrink: 0;
        font-family: Arial, Helvetica, sans-serif;
        cursor: move;
        .new-request-circ {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 24px;
            height: 24px;
            border-radius: 12px;
            position: relative;
            right: 12px;
            background: #31363C;
            margin: 0 8px;
            padding: 3px 0px;
            span {
                position: relative;
                top: 2px;
            }
        }
        .new-request__img{
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: 5px;
        }
        .new-request__text{
            font-family: Arial, Helvetica, sans-serif;
            font-size: 14px;
            color: #C3C5C6;
            padding: 0px 10px;
            display: flex;
            flex-direction: row;
            h3 {
                font-size: 14px;
                color: #C3C5C6;
            }
            .app-icon {
                margin-right: 5px
            }
        }
    }
</style>
